"use client";

import { usePlatform } from "@/app/hooks/usePlatform";
import { useCookies } from "next-client-cookies";
import { useLocale, useTranslations } from "next-intl";
import Image from "next/image";
import { Link } from "@/i18n/navigation";
import React, { useEffect, useState, useCallback } from "react";

const MIN_ANDROID_VERSION = 7180000;
const MIN_IOS_VERSION = 202507180000;
const BANNER_URL = "https://www.gate.com/announcements/article/47065";

const BannerSection = () => {
  const t = useTranslations("HomePage");
  const cookies = useCookies();
  const androidVersion = cookies.get("android_build");
  const iosVersion = cookies.get("ios_build");

  const platform = usePlatform();

  const [shouldShowBanner, setShouldShowBanner] = useState(
    platform === "unknown" ? true : false
  );

  const locale = useLocale();

  useEffect(() => {
    if (platform === "android") {
      setShouldShowBanner(
        androidVersion ? Number(androidVersion) >= MIN_ANDROID_VERSION : false
      );
      return;
    }

    if (platform === "ios") {
      setShouldShowBanner(
        iosVersion ? Number(iosVersion) >= MIN_IOS_VERSION : false
      );
      return;
    }

    setShouldShowBanner(true);
  }, [androidVersion, iosVersion, platform]);

  const handleBannerClick = useCallback(() => {
    if (
      typeof window !== "undefined" &&
      typeof window.openGatePage === "function"
    ) {
      window.openGatePage(BANNER_URL);
      return;
    }

    if (platform === "ios") {
      window.location.href = BANNER_URL;
    } else {
      window.open(BANNER_URL, "_blank");
    }
  }, [platform]);

  if (!shouldShowBanner) return null;

  return (
    <div className="container mx-auto bg-lightwhite dark:bg-sleap-gray-900">
      <div className="md:py-10 py-6 flex flex-col gap-4">
        <h3 className="text-sleap-gray-950 dark:text-white text-[28px] leading-7 font-switzer font-bold mb-0 md:hidden block">
          {t("specialBanner")}
        </h3>

        {platform === "unknown" ? (
          <Link href={BANNER_URL} target="_blank">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={`/assets/v2/images/banner-img-${locale}.webp`}
              className="w-full rounded-2xl block"
              alt="Banner"
              width={1600}
              height={337.5}
              fetchPriority="high"
              loading="eager"
              decoding="sync"
            />
          </Link>
        ) : (
          <div onClick={handleBannerClick} className="cursor-pointer">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={`/assets/v2/images/banner-img-${locale}.webp`}
              className="w-full rounded-2xl"
              alt="Banner"
              width={1600}
              height={338}
              fetchPriority="high"
              loading="eager"
              decoding="sync"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default BannerSection;
